// extracted by mini-css-extract-plugin
export var currentStep = "_fa-2";
export var nodeCard = "_fa-0";
export var pathHighlighted = "_fa-1";